module.exports = __webpack_public_path__ + "img/main-logo-2.93284ddf.jpeg";